import React from 'react';

import { ProductCard, Props as CardProps } from "../ProductCard"
import * as styles from './styles.module.scss';

import fasterIC from 'src/images/products/faster.svg';
import memoryIC from 'src/images/products/memory.svg';
import resourcesIC from 'src/images/products/resources.svg';
import cls from "classnames";

export const cards3: Item[]  = [
  {
    id: 1,
    icon: fasterIC,
    title: 'Deploy faster 48x',
    description: 'Modern cloud organizations entrust BellSoft to ensure',
    className: styles.card,
    childrenClassNames: {
      icon: styles.icon,
      title: 'color-white',
      description: 'color-gray',
    },
  },
  {
    id: 2,
    icon: memoryIC,
    title: 'Save memory up to 40%',
    description: 'Modern cloud organizations entrust BellSoft to ensure',
    className: styles.card,
    childrenClassNames: {
      icon: styles.icon,
      title: 'color-white',
      description: 'color-gray',
    },
  },
  {
    id: 3,
    icon: resourcesIC,
    title: 'Reduce resources by 30%',
    description: 'Modern cloud organizations entrust BellSoft to ensure',
    className: styles.card,
    childrenClassNames: {
      icon: styles.icon,
      title: 'color-white',
      description: 'color-gray',
    },
  }
]

export const cards2: Item[]  = [
  {
    id: 2,
    icon: memoryIC,
    title: 'Save memory up to 40%',
    description: 'Modern cloud organizations entrust BellSoft to ensure',
    className: styles.card,
    childrenClassNames: {
      icon: styles.icon,
      title: 'color-white',
      description: 'color-gray',
    },
  },
  {
    id: 3,
    icon: resourcesIC,
    title: 'Reduce resources by 30%',
    description: 'Modern cloud organizations entrust BellSoft to ensure',
    className: styles.card,
    childrenClassNames: {
      icon: styles.icon,
      title: 'color-white',
      description: 'color-gray',
    },
  }
]

export type Item = CardProps & { id: number }

type Props = {
  items: Item[]
  className: string
  bg: string
}

const MAX_COLUMNS_COUNT = 3;

export const Advantages = ({ items, className, bg }: Props) => {
  return (
      <div className={cls(styles.container, bg ? "bg-" + bg: "bg-dark", className)}>
      <div className="bs-flex-container l">
        <div className={styles.cards} style={{ gridTemplateColumns: `repeat(${Math.min(items.length, MAX_COLUMNS_COUNT)}, 1fr)` }}>
          {items.map(card => {
            if (card.childrenClassNames) {
              card.childrenClassNames.title = cls(card.childrenClassNames.title, styles.title)
              card.childrenClassNames.description = cls(card.childrenClassNames.description, styles.description)
            }
            return <ProductCard key={card.id} {...card} />
          })}
        </div>
      </div>
    </div>
  )
}

